import React from 'react';
import { CortisolSwitchPage } from './pages/CortisolSwitchPage';
export function App() {
  return <CortisolSwitchPage data-id="element-0" />;
}